import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import {
  Input,
  withConnect,
  withReducer
} from 'containers/Form/Input/index'

import {
  getValueSelector
} from 'containers/Form/Input/selectors'

import withEmptyValidation from 'containers/Form/Util/Validation/empty'
import withSagas from './sagas'

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id),
  withEmptyValidation(path, id, getValueSelector(path, id)),
  withSagas(path, id),
)(Input))
